import React from "react";
import ColorHelper from "../../helper/ColorHelper";
import ChatMsgHelper from "../Chat/ChatMsgHelper";
import GroupingImages from "./GroupingImages/GroupingImages";
import "./RightChat.scss";

const RightChat = ({ msg, hour, messageType }) => {
  const [htmlReturn, setHtmlReturn] = React.useState();
  const [groupImage, setGroupImage] = React.useState();
  React.useEffect(() => {
    if (messageType === "image") {
      setGroupImage(msg.split("^^"));
    } else {
      setHtmlReturn(ChatMsgHelper.transformMessage(msg));
    }
  }, [msg]);

  let color = React.useState(
    ColorHelper.getInstance().getRightChatColorStyle()
  )[0];
  return (
    <div className="rightchat-container">
      <div className="hour">{hour}</div>
      {messageType !== "image" ? (
        <div className="msg right">
          {htmlReturn}
        </div>
      ) : (
        <div className="msg right">
          <GroupingImages arr={groupImage ? groupImage : []} />
        </div>
      )}
    </div>
  );
};

export default RightChat;
